// import React from 'react'
// import { Link } from 'react-router-dom';
// import './Navbar.css'
// const Navbar = () => {
//     return (
//         <nav className='bg-[#003a76] z-99 w-screen md:fixed flex flex-row  px-[10%] py-4 shadow-2xl'>
//             <div className='md:w-[40%] w-0 md:visible invisible'>
//                 <Link to="/" className="text-white font-[Acme] text-3xl mx-5 font-normal" href="#">&#60; Suraj /&#62;</Link>
//             </div>

//             <ul className="w-screen  flex md:flex-row flex-col md:gap-16  gap-5 text-white">
//                 <li className=" self-center"><Link to="/home" className="font-medium text-lg text-white hover:border-b-2">Home</Link>
//                 </li>
//                 <li className=" self-center"><Link to="/aboutme" className="font-medium text-lg text-white hover:border-b-2">About Me</Link></li>
//                 <li className=" self-center"><Link to="/experiences" className="font-medium text-lg text-white hover:border-b-2">Experiences</Link></li>
//                 <li className=" self-center"><Link to="/projects" className="font-medium text-lg text-white hover:border-b-2">Projects</Link></li>
//                 <li className=" self-center"><Link to="/contactme" className="font-medium text-lg text-white hover:border-b-2">Contact Me</Link></li>

//             </ul>

//         </nav>
//     )
// }
// export default Navbar;
import { React, useState } from 'react'
import { Link } from 'react-router-dom';
import './Navbar.css'
const Navbar = () => {
    const [isMenuOpen, setIsOpenMenu] = useState(false)

    const menuButtonPressed = () => {
        setIsOpenMenu(!isMenuOpen);// menu Opened
        document.getElementById('logo').style.display = "none";
        document.getElementById('menu').style.display = "flex";
        document.getElementById('menu-button').style.display = "none";

    };
    const menuCLosed=()=>{
        setIsOpenMenu(!isMenuOpen);// Menu Closed
        document.getElementById("logo").style.display='flex'
        document.getElementById("menu").style.display='none'
        document.getElementById("menu-button").style.display='grid'

    }
    return (
        <nav className='bg-[#003a76] z-50 w-screen md:fixed flex flex-row md:px-[10%] py-4 shadow-2xl'>
            <div id='logo' className='w-1/2 flex'>
                <Link to="/" className="text-white font-[Acme] text-3xl mx-5 font-normal" href="#">&#60; Suraj /&#62;</Link>
            </div>

            <ul className="w-screen text-center md:flex md:flex-row flex-col md:gap-16 hidden gap-5 text-white">
                <li className=" self-center "><Link to="/home" className="font-medium text-lg text-white hover:border-b-2">Home</Link>
                </li>
                <li className=" self-center"><Link  to="/aboutme" className="font-medium text-lg text-white hover:border-b-2">About Me</Link></li>
                <li className=" self-center"><Link  to="/experiences" className="font-medium text-lg text-white hover:border-b-2">Experiences</Link></li>
                <li className=" self-center"><Link  to="/projects" className="font-medium text-lg text-white hover:border-b-2">Projects</Link></li>
                <li className=" self-center"><Link  to="/contactme" className="font-medium text-lg text-white hover:border-b-2">Contact Me</Link></li>

            </ul>
            <div id='menu-button' className=' grid md:hidden w-1/2 place-self-center'>
                <button className=' justify-self-end w-fit mr-5' onClick={menuButtonPressed}><img alt='' src='/assests/menu.png'></img></button>

            </div>
            <ul id='menu' className="w-screen text-center hidden md:hidden md:flex-row flex-col md:gap-16 gap-5 text-white">
                <li className=" self-center "><Link onClick={menuCLosed} to="/home" className="font-medium text-lg text-white hover:border-b-2">Home</Link>
                </li>
                <li className=" self-center"><Link onClick={menuCLosed} to="/aboutme" className="font-medium text-lg text-white hover:border-b-2">About Me</Link></li>
                <li className=" self-center"><Link onClick={menuCLosed} to="/experiences" className="font-medium text-lg text-white hover:border-b-2">Experiences</Link></li>
                <li className=" self-center"><Link onClick={menuCLosed} to="/projects" className="font-medium text-lg text-white hover:border-b-2">Projects</Link></li>
                <li className=" self-center"><Link onClick={menuCLosed} to="/contactme" className="font-medium text-lg text-white hover:border-b-2">Contact Me</Link></li>

            </ul>
        </nav>
    )
}
export default Navbar;